import { graphql } from '~publish/graphql'
import { useTypedMutation } from '~publish/hooks/useTypedMutation'

export const RefreshFeed = graphql(/* GraphQL */ `
  mutation RefreshFeed($input: RefreshFeedInput!) {
    refreshFeed(input: $input) {
      __typename
      ... on FeedActionSuccess {
        __typename
        feed {
          __typename
          id
          lastRefreshed
        }
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useRefreshFeed = () =>
  useTypedMutation(RefreshFeed, (data) => data.refreshFeed, {
    successTypename: 'FeedActionSuccess',
    refetchQueries: ['GetFeedDetails', 'GetFeedItems'],
  })
